<template>
    <v-menu offset-y left min-width="180">
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon small aria-label="Ações" v-bind="attrs" v-on="on" @click.stop>
                <v-icon size="20" class="ui-cell-chevron">mdi-dots-horizontal</v-icon>
            </v-btn>
        </template>
        <v-list dense class="ui-row-actions">
            <v-list-item v-for="action in visibleActions" :key="action.text" :disabled="action.disabled" @click="action.handler">
                <v-list-item-icon v-if="action.icon" class="mr-3">
                    <v-icon size="18" :color="action.danger && !action.disabled ? '#dc2626' : undefined">{{ action.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title :class="{ 'ui-row-actions__danger': action.danger && !action.disabled }">{{ action.text }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
// Menu "⋯" da linha da tabela. actions: [{ text, icon?, handler, disabled?,
// danger?, hidden? }]. O clique no botao nao dispara o clique da linha.
export default {
    name: "UiRowActions",
    props: {
        actions: { type: Array, required: true },
    },
    computed: {
        visibleActions() {
            return this.actions.filter((action) => !action.hidden);
        },
    },
};
</script>
